<template>
  <main class="container search-page-wrap">
  	<div class="row">
  		<div class="col-12 offset-md-2 col-md-8 offset-lg-2 col-lg-8 white-box search-area-wrap no-pad-both">

        <div class="col-12" id="search-field-area">
  				<div>
  					<input type="text" @keyup="search" class="form-control" id="search-field" placeholder="Søg efter tema, sted, vej eller adresse" aria-label="Søg efter tema, sted, vej eller adresse" autocomplete="off" autofocus v-model="inputValue">
  				</div>
          <div class="col-12 no-pad-both search-help-box">
  					<p class="blue-text" id="search-show-help-link" @click="showHelp" tabindex="0" role="button">Fandt du ikke hvad du søgte efter?</p>
  				</div>
  			</div>

  			<p class="sr-only">Liste over søge resultater</p>
  			<div class="col-12 no-pad-both search-results-box">

          <div id="search-results" class="col-12">

            <ul v-if="noResults">
              <li class="search-no-result">
			          <p>Vi kunne ikke finde {{ inputValue }}. Hvis ingen af de 3 tip nedenfor hjælper, kan du foreslå {{inputValue}} som sted i Odense Rundt, ved at kontakte os på <a href="mailto:odenserundt@odense.dk">OdenseRundt@odense.dk</a>.<br></p>
    			      <p>
    			         Tip 1: Tjek om din søgning er stavet korrekt.<br><br>
			             Tip 2: Prøv at lave mellemrum foran "vej" eller "gade" i vejnavne. Veje med personnavne er ofte opdelt i flere led. Det hedder for eksempel Jens Juels Vej.<br><br>
			             Tip 3: Prøv at skrive lidt mindre af navnet og se, om der dukker søgeforslag op i listen under søgefeltet.<br><br>
  			        </p>
      			  </li>
            </ul>

            <ul class="search-list" v-show="tagsResult.length != 0">
              <li class="search-header">Temaer</li>
              <template v-for="(tag,index) in tagsResult">
                <SearchTagResult :tagData="tag" :key="index"></SearchTagResult>
              </template>
            </ul>

            <ul class="search-list" v-show="itemResult.length != 0">
              <li class="search-header">Steder og adresser</li>
              <template v-for="(item,index) in itemResult">
                <SearchItemResult :resultData="item" :key="index" :tagList="SmartSearch.tagList"></SearchItemResult>
              </template>
            </ul>

          </div>
  			</div>

  		</div>
  	</div>
  </main>
</template>

<script>
import SmartSearch from '@/assets/SmartSearch.js'
import SearchItemResult from '@/components/search/SearchItemResult.vue'
import SearchTagResult from '@/components/search/SearchTagResult.vue'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      inputValue: '',
      searchResultData: [],
      itemResult: [],
      tagsResult: [],
      noResults: false,
      searchActive: false,
      timeout: false,
    }
  },
  components: {
    SearchItemResult, SearchTagResult,
  },
  created() {
    this.SmartSearch = SmartSearch;
    this.$HelperFunctions.scrollToTop();
    this.$HelperFunctions.setPageTitle('Søg');
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus();
    if(window.lastUsedSearchPhrase != undefined && window.lastUsedSearchPhrase != '') {
      this.inputValue = window.lastUsedSearchPhrase;
      setTimeout(() => {
        this.search();
      }, 50);
    }
  },
  methods: {
    search() {
      var input = document.getElementById('search-field');
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if(this.inputValue.length > 2) {
          window.lastUsedSearchPhrase = this.inputValue;
          this.$root.$emit('toggleLoadingScreen', true);
          setTimeout(() => {
            this.searchActive = true;
        		SmartSearch.searchAddresses(input, data => {
              this.searchResultData = data;
              //console.log(this.searchResultData);
              this.$HelperFunctions.trackSession('search', this.inputValue);
              this.showSearchResults();
        		});
          }, 500);
        }
        else {
          this.searchActive = false;
          this.searchResultData = [];
          this.tagsResult = [];
          this.itemResult = [];
          this.$root.$emit('toggleLoadingScreen', false);
        }
      }, 1000);
  	},
    showSearchResults() {
      setTimeout(() => {
        this.$root.$emit('toggleLoadingScreen', false);
      }, 500);
      this.searchActive = false;
  		if(this.searchResultData.length == 0 && SmartSearch.tagsResults.length == 0) {
  			this.noResults = true;
  		}
  		else {
        this.noResults = false;
        this.tagsResult = SmartSearch.tagsResults;
        this.itemResult = this.searchResultData;
  		}
    },
    showHelp() {
      var obj = {message: '<p>Tip 1: Tjek om din søgning er stavet korrekt.<br><br>\
      Tip 2: Prøv at lave mellemrum foran vej eller gade i vejnavne. Veje med personnavne er ofte opdelt i flere led. Det hedder for eksempel Jens Juels Vej.<br><br>\
      Tip 3: Prøv at skrive lidt mindre af navnet, og se om der dukker søgeforslag op i listen under søgefeltet.\
      </p>', btnText: 'Ok'};
      EventBus.$emit('openMessageBox', obj);
    }
  },
}
</script>

<style lang="scss" scoped>
.search-page-wrap {
  padding-top: 10px;
  padding-bottom: 10px;
}

.search-area-wrap {
	height: 100%;
  min-height: 80px;
}

.search-no-result {
	line-height: 20px;
  min-height: 40px;
  vertical-align: middle;
}

.search-header {
	margin-top: 10px;
  border-bottom: 1px solid rgba(190, 190, 190, 0.5);
	font-weight: bold;
}

.search-list a:hover {
	text-decoration: none;
}

.search-help-box {
  text-align: right;
}

#search-show-help-link {
	padding-top: 8px;
	text-decoration: underline;
  cursor: pointer;
}

/*Portrait - XS*/
@media screen and (max-width: 767px) {
	#search-field-area {
		position: fixed;
		left: 0;
		padding-top: 8px;
		z-index: 2;
	}

	#search-results:empty {
    margin-bottom: 50px;
    padding-top: 0px;
		padding-bottom: 0px;
	}

	#search-results {
		/*padding-bottom: 100px;*/
		padding-left: 5px !important;
		padding-right: 5px !important;
		padding-top: 40px;
	}
}

/*Portrait - SM*/
@media screen and (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
	#search-field-area {
		padding: 10px 15px;
		z-index: 2;
	}
	#search-results {
		margin-bottom: 0px;
	}
}

/*Landscape - MD*/
@media screen and (min-width: 992px) and (max-width: 1199px) and (orientation: landscape) {
	#search-field-area {
		margin-top: 10px;
	}
	.search-results-box {
		position: relative;
		height: calc(100% - 82px);
	}
	#search-results {
		overflow-y: auto;
		height: 100%;
	}
}
/*Landscape - LG*/
@media screen and (min-width: 1200px) and (orientation: landscape) {
	#search-field-area {
		margin-top: 10px;
		margin-bottom: 10px;
	}
	.search-results-box {
		position: relative;
		height: calc(100% - 82px);
	}
	#search-results {
		overflow-y: auto;
		height: 100%;
	}
}

@media only screen and (-webkit-min-device-pixel-ratio : 2) {
	.search-no-result {
		font-size: 15px !important;
	}
}
</style>
